window.websiteFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="'+value+'" target="_blank" rel="noopener noreferrer">';
        html += row.website_formatted;
        html += '</a>';
    }
    return html;
}
